/**
 * DreamChild: relabel Shopify's dynamic checkout button from "Buy it now" to "Buy now".
 * The text is injected by Shopify's `shopify-payment-button` web component (not the theme),
 * so we patch it after render and keep watching for re-renders (e.g. variant changes).
 */
(function () {
  var TARGET = '.shopify-payment-button__button--unbranded';

  function relabel() {
    document.querySelectorAll(TARGET).forEach(function (btn) {
      if (btn.dataset.relabelled === '1') return;
      var text = (btn.textContent || '').trim();
      if (/buy it now/i.test(text)) {
        // Replace the text node only, preserving any spinner/child markup.
        var replaced = false;
        btn.childNodes.forEach(function (node) {
          if (node.nodeType === 3 && /buy it now/i.test(node.textContent)) {
            node.textContent = node.textContent.replace(/buy it now/i, 'Buy now');
            replaced = true;
          }
        });
        if (!replaced) btn.textContent = 'Buy now';
        btn.dataset.relabelled = '1';
      }
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      relabel();
    });
  }

  function init() {
    relabel();
    // Shopify injects/refreshes the button asynchronously and on variant change.
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
